export default {"src":"/_next/static/media/networkNodeIcon.ce08b78f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};